import {CommonState} from '../types/state'
import {isEditor, isMobile} from './environment'
import {isDemo, isTemplate} from './instance'

export const isShowcase = (state: CommonState) =>
  isDemo(state) || isTemplate(state) || isEditor(state) || isMobile(state)
